import OnboardEnterpriseMember from './OnboardEnterpriseMember.page';

export default OnboardEnterpriseMember;
